import { useQuery } from "@/api/utils/useQuery"
import { HasuraQueries } from "@/api/hasura/queries"
import { QueryResult } from "@/api/utils/types"
import { WarrantsAccountWhitelistParser } from "@/models/admin/warrantsAccountWhitelist/warrantsAccountWhitelist.parser"
import { IWarrantsAccountWhitelist } from "@/models/admin/warrantsAccountWhitelist/warrantsAccountWhitelist.types"
import {
  Financials_Warrants_Accounts_Whitelist_Bool_Exp,
  Financials_Warrants_Accounts_Whitelist_Order_By,
  GetWarrantsAccountsWhitelistQuery,
} from "@/api/hasura/generated/graphql"

export interface WarrantsAccountWhitelistListResult {
  whitelist: IWarrantsAccountWhitelist[]
  totalCount: number
}

class WarrantsAccountWhitelistServiceClass {
  getWhitelist(
    search: string,
    page: number,
    pageSize: number,
    orderBy: Financials_Warrants_Accounts_Whitelist_Order_By,
  ): QueryResult<WarrantsAccountWhitelistListResult> {
    const where: Financials_Warrants_Accounts_Whitelist_Bool_Exp = {
      account_number: { _ilike: `%${search}%` },
    }

    return useQuery({
      ...HasuraQueries.warrants.whitelist(
        (page - 1) * pageSize,
        pageSize,
        where,
        orderBy,
      ),
      useRawResponse: true,
      placeholderData: { whitelist: [], totalCount: 0 },
      parserFn: (
        data: GetWarrantsAccountsWhitelistQuery,
      ): WarrantsAccountWhitelistListResult => ({
        whitelist: data.financials_warrants_accounts_whitelist.map(
          WarrantsAccountWhitelistParser.toDomain,
        ),
        totalCount:
          data.financials_warrants_accounts_whitelist_aggregate.aggregate
            ?.count ?? 0,
      }),
    })
  }
}

export const WarrantsAccountWhitelistService =
  new WarrantsAccountWhitelistServiceClass()
